import Alcada from '../../spa/alcada/AlcadaCadastro';

export default {
  path: 'alcada',
  name: 'alcada',
  component: Alcada,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/alcada.js